import React from 'react';

function ParkingSignIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_3847_43897)">
        <path
          fill="#000"
          d="M12.6 6H8.4v12h2.4v-3.6h1.8c2.28 0 4.2-1.92 4.2-4.2 0-2.28-1.92-4.2-4.2-4.2zm0 6h-1.8V8.4h1.8c.96 0 1.8.84 1.8 1.8 0 .96-.84 1.8-1.8 1.8z"
        ></path>
        <rect width="22" height="22" x="1" y="1" stroke="#000" strokeWidth="2" rx="3"></rect>
      </g>
      <defs>
        <clipPath id="clip0_3847_43897">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ParkingSignIcon;
